export default __webpack_public_path__ + "static/media/ic_form.ab6480b2.svg";